var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThermometerVeryHighRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 11.1458V3.99999C13.3333 2.34314 11.8409 1 10 1C8.15906 1 6.66668 2.34314 6.66668 3.99999V11.1458C5.64375 11.9698 5 13.1673 5 14.5C5 16.9853 7.23859 19 10 19C12.7614 19 15 16.9853 15 14.5C15 13.1673 14.3563 11.9698 13.3333 11.1458ZM10 17.5C8.15906 17.5 6.66668 16.1568 6.66668 14.5C6.66668 13.6339 7.07453 12.8304 7.7782 12.2635L8.33336 11.8163V3.99999C8.33336 3.17157 9.07957 2.49998 10 2.49998C10.9205 2.49998 11.6667 3.17153 11.6667 3.99999V11.8163L12.2219 12.2635C12.9255 12.8304 13.3334 13.6338 13.3334 14.5C13.3333 16.1568 11.8409 17.5 10 17.5Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16675 4.03C9.16675 3.56976 9.53985 3.19922 10.0001 3.19922C10.4603 3.19922 10.8334 3.56976 10.8334 4.03V12.3773C11.8044 12.6862 12.5 13.5196 12.5 14.4992C12.5 15.7418 11.3807 16.7492 10 16.7492C8.61929 16.7492 7.5 15.7418 7.5 14.4992C7.5 13.5195 8.19571 12.6861 9.16675 12.3772V4.03Z",
    fill: "#F44336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometerVeryHighRed);
export default __webpack_public_path__ + "static/media/thermometer_very_high_red.035e9c420458af33f6cf703b46ccd649.svg";
export { ForwardRef as ReactComponent };